import React from 'react';

const SEAT_COLORS = {
  Standard: '#4caf50',
  Wheelchair: '#2196f3',
  POD: '#9c27b0',
  Reserved: '#9e9e9e',
  NotExist: 'transparent',
};

export default function SeatMap({ props: p, onAction, partId, disabled, dir }) {
  const floors = p.floors || [];
  const seats = p.seats || [];
  const selected = new Set(p.selected || []);
  const liveUpdate = p.liveUpdate;

  if (!seats.length && !floors.length) {
    return <div className="ui-seat-map empty" dir={dir}>No seat data</div>;
  }

  const maxRow = Math.max(...seats.map((s) => s.row || 0), 0);
  const maxCol = Math.max(...seats.map((s) => s.column || 0), 0);

  const seatAt = (row, col) => seats.find((s) => s.row === row && s.column === col);

  return (
    <div className="ui-seat-map" dir={dir}>
      <div className="ui-part-title">Select seats</div>
      {liveUpdate && <div className="ui-seat-live-hint">Live updates active</div>}
      <div
        className="ui-seat-grid"
        style={{ gridTemplateColumns: `repeat(${maxCol}, 36px)` }}
      >
        {Array.from({ length: maxRow }, (_, ri) => ri + 1).map((row) =>
          Array.from({ length: maxCol }, (_, ci) => ci + 1).map((col) => {
            const seat = seatAt(row, col);
            if (!seat || seat.type === 'NotExist') {
              return <div key={`${row}-${col}`} className="ui-seat empty" />;
            }
            const isReserved = seat.isReserved || seat.type === 'Reserved';
            const isSelected = selected.has(seat.id);
            const available = seat.isAvailableForBooking && !isReserved;
            return (
              <button
                key={seat.id}
                type="button"
                title={seat.seatNumber || seat.id}
                className={`ui-seat${isSelected ? ' selected' : ''}${!available ? ' unavailable' : ''}`}
                style={{ background: isSelected ? '#ff9800' : SEAT_COLORS[seat.type] || '#ccc' }}
                disabled={disabled || !available}
                onClick={() =>
                  onAction?.({
                    actionId: 'seat.toggle',
                    mode: 'patch',
                    payload: { seat_id: seat.id },
                    partId,
                  })
                }
              >
                {seat.seatNumber || ''}
              </button>
            );
          })
        )}
      </div>
      <div className="ui-seat-legend">
        <span>Selected: {selected.size}</span>
        {p.availableCounts && (
          <span>Available: {JSON.stringify(p.availableCounts)}</span>
        )}
      </div>
      <button
        type="button"
        className="ui-btn primary"
        disabled={disabled || selected.size === 0}
        onClick={() =>
          onAction?.({
            actionId: 'seat.done',
            mode: 'turn',
            payload: { seat_ids: [...selected] },
            partId,
          })
        }
      >
        Continue
      </button>
    </div>
  );
}
